import { FunctionComponent } from 'react';
import { Div } from '@gaiads/telia-react-component-library';

export const QuestionsAndAnswers: FunctionComponent = () => {
  return <Div data-testid="questions-and-answers"></Div>;
};
